import React, { useEffect, useState, useCallback, useRef } from "react";
import { Chart } from "react-google-charts";
import { Route, Link, Routes, useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useTranslation } from "react-i18next";
import useAuth from '../../hooks/useAuth';
import {
    AppstoreOutlined, MailOutlined, SettingOutlined, MenuUnfoldOutlined, MenuFoldOutlined, ToolOutlined, DeleteOutlined, DragOutlined,
    FontSizeOutlined,
    BarcodeOutlined,
    BorderOutlined,
    LineOutlined,
    QrcodeOutlined,
    MinusCircleOutlined,
    DownloadOutlined,
    UploadOutlined,
    LoadingOutlined,
    FilePdfOutlined

} from '@ant-design/icons';
import { Spin, Select, List, Alert, Flex, Collapse, Button, Menu, Layout, Result, FloatButton, ConfigProvider, Affix, Tabs, Space, Table, Tag, InputNumber, Input, ColorPicker, Tree, Col, Row, Slider, QRCode, Divider } from 'antd';
import * as XLSX from 'xlsx';

import CardList from "./components/CardList";
import CardExec from "./components/CardExec";

//planner (Cria as tasks)
//conductor (inicia, acompanha e altera os status das tasks)
//executor (executa as tasks)
import exeWorker from "./workers/executorWorker";
import createWebWorker from './workers/WebWorker';
import { downloadAnalisePdf } from './AnaliseCombinacoesPDF';
import {
    LOTTERY_MODALITIES as modalidades,
    getLotteryModalityLabel,
} from '../../constants/lotteryModalidades';
import "./styles/analise-chart.css";

const ExcelJS = require("exceljs");

const CHART_MIN_HEIGHT = 240;
const CHART_MAX_HEIGHT = 420;
const CHART_MAX_WIDTH = 1200;

const SorteioSemSairChart = ({ data, options }) => {
    const containerRef = useRef(null);
    const [size, setSize] = useState({ width: 0, height: CHART_MIN_HEIGHT });

    useEffect(() => {
        const updateSize = () => {
            if (!containerRef.current) return;

            const availableWidth = containerRef.current.clientWidth;
            const width = Math.min(availableWidth, CHART_MAX_WIDTH);
            const viewportHeight = Math.round(window.innerHeight * 0.4);
            const height = Math.min(
                Math.max(viewportHeight, CHART_MIN_HEIGHT),
                CHART_MAX_HEIGHT
            );

            setSize((prev) => (
                prev.width === width && prev.height === height
                    ? prev
                    : { width, height }
            ));
        };

        updateSize();

        const observer = new ResizeObserver(updateSize);
        observer.observe(containerRef.current);
        window.addEventListener('resize', updateSize);

        return () => {
            observer.disconnect();
            window.removeEventListener('resize', updateSize);
        };
    }, [data]);

    return (
        <div ref={containerRef} className="analise-chart-container">
            {size.width > 0 && (
                <div className="analise-chart-inner">
                    <Chart
                        chartType="Line"
                        width={size.width}
                        height={size.height}
                        data={data}
                        options={options}
                    />
                </div>
            )}
        </div>
    );
};

let hist_list = [];

let modalidade_sel_val = "";

const TLSAnaliseCombinacoes = () => {

    window.scrollTo(0, 0);

    const { auth, habRoles } = useAuth();
    const hab_func = habRoles(['F0E017C0-CEF9-4089-9391-31F95D00B28F']);
    const navigate = useNavigate();

    const { t, i18n: { changeLanguage, language } } = useTranslation();
    const axiosPrivate = useAxiosPrivate();

    const [result_analise, setResAnalise] = useState<any>(null);
    const [running, setRunning] = useState(false);
    const [finish, setFinish] = useState(false);
    const [sel_num, setSelNum] = useState<any>(null);
    const [sort_sem_sair, setSortSemSair] = useState<any[]>([]);

    const [modalidade_sel, setModalidadeSel] = useState("");
    const [exportingPdf, setExportingPdf] = useState(false);

    const handleChange = (value) => {
        //console.log(value);
        modalidade_sel_val = value;
        setModalidadeSel(value);
    };

    const options = {
        legend: { position: "none" },
        pointSize: 5,
        chartArea: {
            width: '82%',
            height: '75%',
            left: '12%',
            top: '8%',
        },
    };

    const inputXlsx = useRef(null);

    const ExcelToJSON = function (e) {

        hist_list = [];

        const file = e.target.files[0];
        const parseExcel = function (file) {

            var reader = new FileReader();
            reader.onload = function (e) {
                var data = e.target.result;
                var workbook = XLSX.read(data, {
                    type: 'binary'
                });
                workbook.SheetNames.forEach(function (sheetName) {

                    const sheet = workbook.Sheets[sheetName];
                    var range = XLSX.utils.decode_range(sheet['!ref']);
                    for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {

                        //process_comb(rowNum);
                        let comb = [];
                        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {

                            const secondCell = sheet[XLSX.utils.encode_cell({ r: rowNum, c: colNum })];
                            //console.log(secondCell);
                            if (secondCell != undefined) {

                                if (secondCell.v != "") {
                                    comb.push(secondCell.v);
                                }
                            }

                        }
                        hist_list.push(comb);
                    }

                    //Realizar validações de acordo com a modalidade

                    //Executa as análises
                    verificaTasks();
                })
            };

            reader.onerror = function (ex) {
                console.log(ex);
            };

            reader.readAsBinaryString(file);

        };
        parseExcel(file);
    };

    const handleFileUpload = useCallback((e) => {

        ExcelToJSON(e);

    }, []);

    const update_sorteio_sem_sair = (num) => {

        let info = [
            ["Sorteio", "Jogos sem sair"]
        ];

        //console.log(result_analise?.numeros[1]?.atraso_graf);

        result_analise?.numeros[1]?.atraso_graf.map((item, index) => {
            info.push([index+1, item[num-1]]);
        })

        setSortSemSair(info);
    }

    useEffect(() => {
        update_sorteio_sem_sair(sel_num);
      }, [sel_num]);

    function verificaTasks() {

        //Inicia o condutor
        let exWebWorker = createWebWorker(exeWorker);
        exWebWorker.addEventListener('message', (event) => {

            let { result } = event.data;

            setSelNum(1);
            

            setResAnalise(result);
            setRunning(false);
            setFinish(true);

            exWebWorker.terminate();

        });
        setRunning(true);
        //console.log(modalidade_sel_val);
        modalidades.map((modalidade, index) => {
            if (modalidade_sel_val === modalidade.value) {
                //console.log(modalidade_sel_val);
                exWebWorker.postMessage({ hist_list: hist_list, max_num: modalidade.qty_disp, num_sorteados: modalidade.qty_result });
            }
        });

    }

    const handleStart = () => {

        inputXlsx.current.value = null;
        inputXlsx.current.click()
    };

    const handleExportPdf = async () => {
        if (!result_analise) return;
        const modalidadeLabel = getLotteryModalityLabel(modalidade_sel);
        setExportingPdf(true);
        try {
            await downloadAnalisePdf(result_analise, modalidadeLabel);
        } catch (error) {
            console.error('Erro ao exportar PDF:', error);
        } finally {
            setExportingPdf(false);
        }
    };

    const items = [
        {
            key: '1',
            label: 'Análise de números',
            children: <Flex wrap gap="small" justify="center">
                <Table
                    style={{ width: "100%" }}
                    bordered
                    pagination={{
                        hideOnSinglePage: true,
                    }}
                    columns={[{
                        title: 'Números disponíveis',
                        dataIndex: 'render',
                        key: '1',
                    }]}
                    dataSource={[
                        {
                            key: '1',
                            render: (
                                <Flex wrap gap="small" justify="center">
                                    {
                                        result_analise?.numeros[0]?.atraso.map((item, index) => (
                                            <Button key={index + 1} shape="circle" type={(sel_num == index + 1) ? "primary" : "default"} onClick={() => { setSelNum(() => { return (index + 1)})}}>{index + 1}</Button>
                                            // <Button key={index + 1} shape="circle" type={(sel_num == index + 1) ? "primary" : "default"} onClick={() => { setSelNum(() => { return (sel_num != index + 1) ? index + 1 : null }); update_sorteio_sem_sair(index + 1)}}>{index + 1}</Button>
                                        ))
                                    }
                                </Flex>
                            )
                        }
                    ]}
                />
                <Table
                    className="analise-chart-table"
                    style={{ width: "100%" }}
                    bordered
                    pagination={{
                        hideOnSinglePage: true,
                    }}
                    columns={[{
                        title: 'Gráfico de jogos sem sair por número',
                        dataIndex: 'render',
                        key: '1',
                    }]}
                    dataSource={[
                        {
                            key: '1',
                            render: (
                                <Flex
                                    vertical
                                    gap="small"
                                    align="stretch"
                                    className="analise-chart-wrapper"
                                    style={{ width: '100%' }}
                                >
                                    <Flex justify="center" gap={8} align="center">
                                        <span
                                            style={{
                                                display: 'inline-block',
                                                width: 28,
                                                height: 4,
                                                backgroundColor: '#3366cc',
                                                borderRadius: 2,
                                            }}
                                        />
                                        <span>
                                            Jogos sem sair
                                            {sel_num ? ` (número ${sel_num})` : ''}
                                        </span>
                                    </Flex>
                                    <SorteioSemSairChart
                                        data={sort_sem_sair}
                                        options={options}
                                    />
                                </Flex>
                            )
                        }
                    ]}
                />
                <Table
                    style={{ width: "100%" }}
                    bordered
                    pagination={{
                        hideOnSinglePage: true,
                    }}
                    columns={[{
                        title: 'A quantos jogos que não sai',
                        dataIndex: 'render',
                        key: '1',
                    }]}
                    dataSource={[
                        {
                            key: '1',
                            render: (
                                <Flex wrap gap="small" justify="center">
                                    {
                                        //console.log(result_analise?.numeros[1]?.intervalo_atraso)}{

                                        result_analise?.numeros[0]?.atraso.map((item, index) => (
                                            <div key={index + 1}><Button shape="circle" type={(sel_num == item.numero) ? "primary" : "default"} onClick={() => { setSelNum(() => { return (item.numero)}) }}>{item.numero}</Button> = {item.atraso}</div>
                                            // <div key={index + 1}><Button shape="circle" type={(sel_num == item.numero) ? "primary" : "default"} onClick={() => { setSelNum(() => { return (sel_num != item.numero) ? item.numero : null });update_sorteio_sem_sair(index + 1) }}>{item.numero}</Button> = {item.atraso}</div>
                                        ))
                                    }
                                </Flex>
                            )
                        }
                    ]}
                />

                <Table
                    style={{ width: "100%" }}
                    bordered
                    pagination={{
                        hideOnSinglePage: true,
                    }}
                    columns={[{
                        title: 'Vezes que saiu',
                        dataIndex: 'render',
                        key: '1',
                    }]}
                    dataSource={[
                        {
                            key: '1',
                            render: (
                                <Flex wrap gap="small" justify="center">
                                    {
                                        result_analise?.numeros[3]?.vezes_saiu.map((item, index) => (
                                            <div key={index + 1}><Button shape="circle" type={(sel_num == item.numero) ? "primary" : "default"} onClick={() => { setSelNum(() => { return (item.numero)}) }}>{item.numero}</Button> = {item.vezes_saiu}</div>
                                            // <div key={index + 1}><Button shape="circle" type={(sel_num == item.numero) ? "primary" : "default"} onClick={() => { setSelNum(() => { return (sel_num != item.numero) ? item.numero : null }) }}>{item.numero}</Button> = {item.vezes_saiu}</div>
                                        ))
                                    }
                                </Flex>
                            )
                        }
                    ]}
                />
            </Flex>,
        },
        {
            key: '2',
            label: 'Análise de sorteios',
            children: <Flex wrap gap="small" justify="center">
                <List
                    header={<b>Sequências por jogo</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[0]?.sequencias}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.sequencias} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Sequência direta máxima por jogo</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[1]?.sequencias_dire_max}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.sequencias_dire_max} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Números pares</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[2]?.num_pares}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.num_pares} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Números da sequência de Fibonacci</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[3]?.qtd_fibonacci}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_fibonacci} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Números primos</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[4]?.qtd_primos}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_primos} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade de linhas</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[5]?.qtd_linhas}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_linhas} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade máxima por linha</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[6]?.qtd_max_linhas}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_max_linhas} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade de colunas</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[7]?.qtd_colunas}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_colunas} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade máxima por coluna</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[8]?.qtd_max_colunas}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_max_colunas} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <Table
                    style={{ width: "100%" }}
                    bordered
                    pagination={{
                        hideOnSinglePage: true,
                    }}
                    columns={[{
                        title: 'Menor número',
                        dataIndex: 'render',
                        key: '1',
                    }]}
                    dataSource={[
                        {
                            key: '1',
                            render: (
                                <Flex wrap gap="small" justify="center">
                                    {
                                        result_analise?.combinacoes[9]?.menor_num.map((item, index) => {
                                            if (item.qtd > 0) {
                                                return (<div key={index + 1}><Button shape="circle" >{item.menor_num}</Button> = {item.qtd}</div>)
                                            }
                                        })
                                    }
                                </Flex>
                            )
                        }
                    ]}
                />
                <Table
                    style={{ width: "100%" }}
                    bordered
                    pagination={{
                        hideOnSinglePage: true,
                    }}
                    columns={[{
                        title: 'Maior número',
                        dataIndex: 'render',
                        key: '1',
                    }]}
                    dataSource={[
                        {
                            key: '1',
                            render: (
                                <Flex wrap gap="small" justify="center">
                                    {
                                        result_analise?.combinacoes[10]?.maior_num.map((item, index) => {
                                            if (item.qtd > 0) {
                                                return (<div key={index + 1}><Button shape="circle" >{item.maior_num}</Button> = {item.qtd}</div>)
                                            }
                                        })
                                    }
                                </Flex>
                            )
                        }
                    ]}
                />
                <List
                    header={<b>Quantidade de quadrantes utilizados (Divisão em 4 quadrantes)</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[11]?.qtd_quad_em_4_quad}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_quad_em_4_quad} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade máxima por quadrante (Divisão em 4 quadrantes)</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[12]?.qtd_max_quad_em_4_quad}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_max_quad_em_4_quad} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'}) | No total existem {item.qtd_all} ({((item.qtd_all / result_analise?.qtd_all) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade que repetiu do jogo anterior</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[13]?.qtd_rep_ultimo}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_rep_ultimo} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade que repetiu nos 2 jogos anteriores</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[14]?.qtd_rep_2_ultimo}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_rep_2_ultimo} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade que repetiu nos 3 jogos anteriores</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[15]?.qtd_rep_3_ultimo}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_rep_3_ultimo} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade que repetiu nos 4 jogos anteriores</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[16]?.qtd_rep_4_ultimo}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_rep_4_ultimo} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                <List
                    header={<b>Quantidade que repetiu nos 5 jogos anteriores</b>}
                    footer={null}
                    bordered
                    style={{ width: "100%" }}
                    dataSource={result_analise?.combinacoes[17]?.qtd_rep_5_ultimo}
                    renderItem={(item: any) => {
                        if (item.qtd > 0 || item.qtd_all > 0) {
                            return (<List.Item>
                                {item.qtd_rep_5_ultimo} = {item.qtd} jogos ({((item.qtd / result_analise?.total_comb) * 100).toFixed(2) + ' %'})
                            </List.Item>)
                        }

                    }}
                />
                {/* <Table
                    style={{ width: "100%" }}
                    bordered
                    pagination={{
                        hideOnSinglePage: true,
                    }}
                    columns={[{
                        title: 'Quantidade que repetiu do jogo anterior',
                        dataIndex: 'render',
                        key: '1',
                    }]}
                    dataSource={[
                        {
                            key: '1',
                            render: (
                                <Flex wrap gap="small" justify="center">
                                    {
                                        result_analise?.combinacoes[13]?.qtd_rep_ultimo.map((item, index) => 
                                        {
                                            if(item.qtd > 0){
                                                return (<div key={index+1} style={{border:"1px solid #006EDF", padding:5, minWidth:"100px"}}>{item.qtd_rep_ultimo} = em {item.qtd} jogos</div>)
                                            }
                                        })
                                    }
                                </Flex>
                            )
                        }
                    ]}                    
                /> */}

            </Flex>,
        },
    ];

    return (
        <>
            <Spin
                spinning={running}
                wrapperClassName="analise-combinacoes-spin"
                indicator={<LoadingOutlined style={{ fontSize: 96 }} spin />}
            >
                <div
                    className={running ? 'analise-combinacoes-spin-content--loading' : undefined}
                    style={{ width: '100%' }}
                >
                {finish && <Alert
                    message={t('msg_analise_padroes.combinacoes_analisadas')}
                    type="success"
                    showIcon
                    closable
                    style={{ marginBottom: 10 }}
                />}
                <Flex wrap gap="small" justify={'center'} align={'center'}>
                    <label>
                        {t('desdobramentos_lot.modalidade')}: <Select
                            disabled={running}
                            defaultValue=""
                            style={{
                                width: 120,
                            }}
                            onChange={handleChange}
                            options={modalidades}
                        />
                    </label>
                </Flex>
                <br />
                <Flex wrap gap="small" justify={'center'} align={'center'}>
                    {!running && modalidade_sel !== "" && (
                        <>
                            <Button onClick={handleStart} icon={<UploadOutlined />}>{t('cadastro_msg.selecionar_arquivo')}</Button>
                            {finish && (
                                <Button
                                    type="primary"
                                    loading={exportingPdf}
                                    onClick={handleExportPdf}
                                    icon={<FilePdfOutlined />}
                                >
                                    Exportar PDF
                                </Button>
                            )}
                        </>
                    )}
                </Flex>
                <input type="file" ref={inputXlsx} onChange={handleFileUpload} style={{ display: 'none' }} />
                <Divider />
                {finish && <Collapse items={items} defaultActiveKey={['1', '2']} />}
                </div>
            </Spin>
        </>
    )
}

export default TLSAnaliseCombinacoes;